import * as types from "../actionTypes";

export const modalData = (data) => {
    return {
        type: types.PREMIUM_FEATURE_MODAL_DATA,
        data
    };
};
export const closeModal = () => {
    return {
        type: types.PREMIUM_FEATURE_CLOSE_MODAL
    };
};